// extracted by mini-css-extract-plugin
export default {"container":"family2-module--container--P+PXM","image-wrapper":"family2-module--image-wrapper--+5lc2","image":"family2-module--image--MkXYO"};